var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocDestinationFlag0YellowC82(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / navi / soc_destination_flag_0_yellow_C8.2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-navi-/-soc_destination_flag_0_yellow_C8.2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "soc_destination_0_destination_flag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1.5 L12,4.5 L16.5,4.5 L16.5,34.5 L1.5,34.5 L1.5,4.5 L6,4.5 L6,1.5 L12,1.5 Z M15,6 L3,6 L3,33 L15,33 L15,6 Z M13.5,30 L13.5,31.5 L4.5,31.5 L4.5,30 L13.5,30 Z",
    id: "battery",
    fill: "#E2B236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75,15 L21.75,34.5 L20.25,34.5 L20.25,15 L21.75,15 Z M25.5,24 L25.5,26.25 L23.25,26.25 L23.25,24 L25.5,24 Z M30,24 L30,26.25 L27.75,26.25 L27.75,24 L30,24 Z M34.5,24 L34.5,26.25 L32.25,26.25 L32.25,24 L34.5,24 Z M27.75,21.75 L27.75,24 L25.5,24 L25.5,21.75 L27.75,21.75 Z M32.25,21.75 L32.25,24 L30,24 L30,21.75 L32.25,21.75 Z M25.5,19.5 L25.5,21.75 L23.25,21.75 L23.25,19.5 L25.5,19.5 Z M30,19.5 L30,21.75 L27.75,21.75 L27.75,19.5 L30,19.5 Z M34.5,19.5 L34.5,21.75 L32.25,21.75 L32.25,19.5 L34.5,19.5 Z M27.75,17.25 L27.75,19.5 L25.5,19.5 L25.5,17.25 L27.75,17.25 Z M32.25,17.25 L32.25,19.5 L30,19.5 L30,17.25 L32.25,17.25 Z M25.5,15 L25.5,17.25 L23.25,17.25 L23.25,15 L25.5,15 Z M30,15 L30,17.25 L27.75,17.25 L27.75,15 L30,15 Z M34.5,15 L34.5,17.25 L32.25,17.25 L32.25,15 L34.5,15 Z",
    fill: "#CCCCCC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocDestinationFlag0YellowC82);
export default __webpack_public_path__ + "static/media/soc_destination_flag_0_yellow_C8.2.6430abb940c0e92b1794ce000e60901c.svg";
export { ForwardRef as ReactComponent };